import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  SOLD_CONTENT_TYPES,
  WATCH_HOME_IDS
} from '../../constants';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import {get} from 'lodash';
import { formatInternationalDate } from '../../utils/date';
import { onHomepage } from '../../utils/dom';

const paidContentLabel = () => (
  <div className="section">
    <RosettaFormattedMessage parentFilename={__filename}
      id="paid_content_label"
      description="Label that appears on paid content hero cards"
      defaultMessage="Paid Content"
    />
  </div>
);

const contentCategoryLabel = (__html) =>
  <div className="section" dangerouslySetInnerHTML={{ __html }} />;

const authorLabel = (name) => (
  <div className="author">
    <RosettaFormattedMessage parentFilename={__filename}
      id="byline"
      description="Author label that appears on hero cards"
      defaultMessage="by {name}"
      values={{
        name: (
          <span className="author-name"
            dangerouslySetInnerHTML={{ __html: name ? name : '' }}
          />
        )
      }}
    />
  </div>
);

export default class HeroCardElements extends Component {
  shouldComponentUpdate = (nextProps, nextState, nextContext) =>
    this.props.id !== nextProps.id
    || this.context.location.pathname !== nextContext.location.pathname;

  label = () =>
    this.props.meta.sold_content_type === SOLD_CONTENT_TYPES.CUSTOM
      ? paidContentLabel()
      : contentCategoryLabel(this.props.label);

  title = () =>
    this.props.hero_shorter_title || this.props.truncated_title_62;

  date = () =>
    <div className="date">
      {
        formatInternationalDate(
          this.context.intl.locale,
          this.context.location
        )
      }
    </div>;

  render() {
    const { moduleTitle, isVideoCard, pageId, isHomepageRefresh, isRefreshCard } = this.props;
    const { location, edition_data } = this.context;

    const onWatchPage = WATCH_HOME_IDS.includes(pageId);

    return (
      <div>
        <div className="hero-overlay" />
        <div className="hero-card-content">
          {onHomepage(location, edition_data) && !isHomepageRefresh && this.date()}
          <h1 className="module-title">
            {!onWatchPage && !isHomepageRefresh && moduleTitle}
          </h1>
          <div className="story-content">
            <div className="story-meta">
              {isVideoCard && <figure className="type icon-video" />}
              {this.label()}
            </div>
            <div className="title">
              <span dangerouslySetInnerHTML={{ __html: this.title() }} />
            </div>
            {!onWatchPage && !isRefreshCard && authorLabel(get(this.props, 'contributors[0].display_name'))}
            {isRefreshCard && (
              <div className="author">
                <span className="author-name" dangerouslySetInnerHTML={{ __html: 'Shop Now' }} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

HeroCardElements.propTypes = {
  contributors: PropTypes.arrayOf(PropTypes.shape({
    display_name: PropTypes.string
  })).isRequired,
  hero_shorter_title: PropTypes.string,
  id: PropTypes.number.isRequired,
  isVideoCard: PropTypes.bool,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    sold_content_type: PropTypes.string
  }),
  moduleTitle: PropTypes.string.isRequired,
  pageId: PropTypes.number.isRequired,
  truncated_title_62: PropTypes.string,
  isHomepageRefresh: PropTypes.bool,
  isRefreshCard: PropTypes.bool
};

HeroCardElements.contextTypes = {
  location: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  edition_data: PropTypes.object
};

HeroCardElements.defaultProps = {
  contributors: [{}],
  label: '',
  truncated_title_62: ''
};
